import type { PatientStatus } from './patientTrackingDashboardTypes';

const PATIENT_STATUS_LABELS: Record<PatientStatus, string> = {
  Pending: 'Pending',
  FollowUp: 'Follow Up',
  OnHold: 'On Hold',
  Reviewed: 'Reviewed',
  Sent: 'Sent',
  Lost: 'Lost',
  Resolved: 'Resolved'
};

export function patientStatusLabel(status: PatientStatus): string {
  return PATIENT_STATUS_LABELS[status];
}

export function truncateIssueText(value: string, maxLength = 72): string {
  const trimmed = value.trim();
  if (trimmed.length <= maxLength) return trimmed;
  return `${trimmed.slice(0, maxLength - 1)}…`;
}

export function formatDashboardTimestamp(value: string): string {
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(value));
}
